<template>
  <div>

    <b-alert class="my-3" show>Clerks, are order processor's and users who manage pallet transfers and adjustments. </b-alert>


    <data-table
      :items="items"
      v-on:updateData="getClerks"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:header-buttons>
        <b-button
          class="ml-2"
          :to="{ name: 'clerks-create' }"
          variant="primary"
        >
          <i class="lni lni-circle-plus m-0"></i>
        </b-button>
      </template>

      <template v-slot:headings>
        <div class="col-lg-1"></div>
        <div class="col-lg-4">Clerk</div>
        <div class="col-lg-5">Branches</div>
      </template>

      <template v-slot:rows="slotProps">
        <div class="col-4 col-lg-1 my-auto">
          <v-lazy-image
            v-if="slotProps.item.image"
            :src="slotProps.item.image"
            class="img-fluid maxHeight50"
          />
        </div>

        <div class="col-8 col-lg-4 my-auto">
          <h5 class="m-0">{{ slotProps.item.name }}</h5>
        </div>

        <div class="col-lg-5 mt-2 my-lg-auto">
          <p class="m-0" v-for="clerk in slotProps.item.clerks" :key="clerk.id">- {{ clerk.branch.name }}</p>
        </div>

        <div class="col-lg-2 my-auto text-left text-lg-right pt-3 pt-md-0">

          <router-link
            v-b-tooltip.hover
            title="Edit"
            :to="{
              name: 'clerks-edit',
              params: { id: slotProps.item.id },
            }"
            class="text-primary table-action-icon"
          >
            <i class="lni lni-pencil"></i>
          </router-link>

          <span
            v-b-tooltip.hover
            style="cursor: pointer"
            title="Delete"
            @click="confirmDelete(slotProps.item.id)"
            class="text-danger table-action-icon"
          >
            <i class="lni lni-trash"></i>
          </span>
        </div>
      </template>
    </data-table>

    <b-modal
      :hide-footer="true"
      :title="$route.meta.title"
      size="lg"
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'clerks' })"
      :lazy="true"
    >
      <router-view
        @clerkCreated="clerkCreated()"
        @clerkUpdated="clerkUpdated()"
      ></router-view>
    </b-modal>


  </div>
</template>

<script>
import clerkRepo from "@/api/repos/clerkRepo";
import dataTable from "@/components/common/DataTable";

export default {
  components: {
    dataTable: dataTable,
  },

  data() {
    return {
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "name", label: "Name Asc", order: "asc" },
      sortOptions: [
        { column: "name", label: "Name Asc", order: "asc" },
        { column: "name", label: "Name Desc", order: "desc" },
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getClerks({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      search: "",
    });
  },
  methods: {
    async deleteClerk(id) {
      this.isBusy = true;
      try {
        await clerkRepo.delete(id);
        this.items = this.items.filter((item) => item.id !== id);
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to delete the clerk.",
          {
            title: "Please Confirm",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((confirm) => (confirm ? this.deleteClerk(id) : false))
        .catch((error) => console.log(error));
    },
    async getClerks(e) {
      this.isLoad = true;
      try {
        let { data } = await clerkRepo.clerks(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.clerks.data;
        this.totalRows = data.clerks.total;
        this.page = data.clerks.current_page;
        this.fromRow = data.clerks.from;
        this.toRow = data.clerks.to;
        this.lastPage = data.clerks.last_page;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    clerkCreated() {
      this.$bvToast.toast("Clerk Created", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sort = {
        column: "created_at",
        label: "Date Created Desc",
        order: "desc",
      };
      this.page = 1;
      this.sidebarToggle = false;
      this.getClerks({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 12,
        search: "",
      });
    },

    clerkUpdated() {
      this.$bvToast.toast("Clerk Updated", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sidebarToggle = false;
      this.getClerks({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 12,
        search: "",
      });
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
